import { Field, FieldProps } from 'formik'
import * as React from 'react'
import Select from 'react-select'
// import Dropdown from 'react-dropdown'
// import 'react-dropdown/style.css'

interface IDropdownOption {
  label: string
  value: any
}

const GenericDropdown = (props: {
  name: string
  options: IDropdownOption[]
  defaultOption: IDropdownOption
  placeholder: string
}) => {
  const getSelect = (field: any, form: any) => {
    const handleSelect = (event: any) => {
      form.setFieldValue(props.name, event.value)
      form.setTouched(props.name)
    }
    const getValue = (value: string) => {
      return props.options.find(o => o.value === parseInt(value, 10))
    }
    const defaultValue = props.options.filter(o => o.value === props.defaultOption.value)[0]

    return (
      <Select
        clearable={false}
        name={props.name}
        value={getValue(form.values[props.name])}
        defaultValue={defaultValue}
        onChange={handleSelect}
        options={props.options}
      />
      // <Dropdown options={props.options} onChange={handleSelect} value={form.values[props.name]} placeholder={props.placeholder} />
    )
  }

  return <Field name={props.name}>{({ field, form }: FieldProps<any>) => <div>{getSelect(field, form)}</div>}</Field>
}

export default GenericDropdown



// WEBPACK FOOTER //
// ./src/components/ui/GenericDropdown.tsx